export default "__VITE_ASSET__DJeShEZ9__"